<template>
  <div class="view-wrapper this-wrapper view-wrapper-master-overlay">
    <div class="view view-master-full">
      <v-toolbar class="my-bar">
        <v-btn v-if="rightFilter('w')" icon @click="add">
          <v-icon>add</v-icon>
        </v-btn>
        <v-btn
          v-if="rightFilter('d')"
          icon
          :disabled="!item"
          @click="dialogDelete = true"
        >
          <v-icon>remove</v-icon>
        </v-btn>
        <v-btn v-if="rightFilter('w')" icon :disabled="!item" @click="addBlank">
          <v-icon>note_add</v-icon>
        </v-btn>
        <v-spacer />
        <ServiceHistory :item="item"></ServiceHistory>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="headline"
            >Вы точно хотите удалить услугу?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="dialogDelete = false">Отмена</v-btn>
              <v-btn color="primary" text @click="deleteConfirm">OK</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="items"
        :items-per-page="-1"
        :single-select="true"
        item-key="id"
        show-select
        hide-default-footer
        :loading="loading"
        loading-text="Загрузка... Пожалуйста подождите"
        fixed-header
        :item-class="itemColor"
        @click:row="rowClick"
      >
        <template v-slot:item.stateKey="{ item }">
          <v-icon v-if="item.stateKey === 'E'" color="green">done</v-icon>
          <v-icon v-else-if="item.stateKey === 'R'" color="blue"
          >arrow_right</v-icon
          >
          <v-icon v-else color="orange">arrow_left</v-icon>
        </template>
      </v-data-table>
    </div>
    <div v-if="item" class="view-detail-overlay">
      <v-toolbar class="my-bar">
<!--        <v-btn
          icon
          :disabled="!serviceDetail || !serviceDetail.valid"
          @click="save"
        >
          <v-icon>save</v-icon>
        </v-btn>-->

        <SaveButton
        :additional-rules="!serviceDetail || !serviceDetail.valid"
        :handler="save"
        >

        </SaveButton>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <ServiceDetail :vm="this"></ServiceDetail>
    </div>
    <CheckLimit :vm="this"></CheckLimit>
  </div>
</template>

<script>
  import fetch from "@/utils/fetch";
  import vm2js from "@/utils/vm2js";
  import js2vm from "@/utils/js2vm";
  import ctx from "@/ctx";
  import dateLocalFilter from "../../filters/dateLocal.filter";
  import dateIsoFilter from "../../filters/dateIso.filter";
  import ServiceDetail from "./ServiceDetail";
  import moment from "moment";
  import CheckLimit from "../balance/Check";
  import rightFilter from "../../filters/right.filter";
  import ServiceHistory from "../invoices/ServiceHistory";
  import SaveButton from "@/components/ButtonFacade";

  const extractServiceFromRow = function(d) {
    const rawService = d.service;
    const nested =
      rawService != null && typeof rawService === "object" ? rawService : null;
    const primitiveId =
      rawService != null &&
      typeof rawService !== "object" &&
      !Number.isNaN(Number(rawService))
        ? rawService
        : null;
    const primitiveName =
      rawService != null &&
      typeof rawService === "string" &&
      Number.isNaN(Number(rawService))
        ? rawService
        : null;

    const id =
      d.serviceId != null
        ? d.serviceId
        : primitiveId != null
          ? primitiveId
          : nested && nested.id;

    const name =
      d.serviceName ||
      d.serviceString ||
      primitiveName ||
      (nested &&
        (nested.name ||
          nested.serviceName ||
          nested.fullName ||
          nested.serviceString));

    return { id, name };
  };

  let Item = function(d, serviceLookup = {}) {
    let self = this;
    const { id: apiServiceId, name: apiServiceName } = extractServiceFromRow(d);

    if (d.serviceId == null && apiServiceId != null) {
      d.serviceId = apiServiceId;
    }

    d.visitDate = !d.visitDate ? new Date() : d.visitDate;
    d.postingDate = !d.postingDate ? new Date() : d.postingDate;
    d.quantity = !d.quantity ? 1 : d.quantity;
    d.amount = !d.amount ? 0 : d.amount;
    d.discountPercent = !d.discountPercent ? 0 : d.discountPercent;

    d.organization = d.organizationId;
    d.doctor = d.doctorId;
    d.diagnosis = d.diagnosisId;
    d.visitDate4List = d.visitDate;
    d.postingDate4List = d.postingDate;
    d.service = d.serviceId;
    d.serviceCategory = d.serviceCategoryId;
    d.diagnosisExt = d.diagnosisExt ? d.diagnosisExt : "";

    self.organization2vm = function(val) {
      if (!val) return {};
      return ctx.src.org.first(val);
    };
    self.doctor2vm = function(val) {
      if (!val) return {};
      return ctx.src.doctors.get(val);
    };

    self.diagnosis2vm = function(val) {
      if (!val) return {};
      return ctx.src.diagnosis.get(val) || {};
    };

    self.visitDate4List2vm = function(val) {
      return dateLocalFilter(val);
    };
    self.postingDate4List2vm = function(val) {
      return dateLocalFilter(val);
    };
    self.visitDate2vm = function(val) {
      return dateIsoFilter(val);
    };
    self.postingDate2vm = function(val) {
      return dateIsoFilter(val);
    };

    self.service2vm = function(val) {
      const serviceId = val != null ? val : apiServiceId;
      if (serviceId == null) return {};
      const fromLookup =
        serviceLookup[serviceId] || serviceLookup[String(serviceId)];
      if (fromLookup) return fromLookup;
      const fromCtx = ctx.src.services.get(serviceId);
      if (fromCtx) return fromCtx;
      if (apiServiceName) return { id: serviceId, name: apiServiceName };
      return {};
    };
    self.serviceCategory2vm = function(val) {
      if (!val) return {};
      return ctx.src.categories.get(val);
    };

    js2vm(self, d);

    const serviceName =
      (self.service && self.service.name) ||
      apiServiceName ||
      (serviceLookup[self.serviceId] &&
        serviceLookup[self.serviceId].name) ||
      "";
    self.serviceName4List = serviceName;
    if ((!self.service || !self.service.name) && serviceName) {
      self.service = { id: self.serviceId, name: serviceName };
    }
  };

  export default {
    props: {
      vm: Object,
      byInvoice: { type: Boolean, default: true }
    },
    data: () => ({
      ctx,
      rightFilter,
      currentPage: 0,
      totalPages: 0,
      loading: false,
      selected: [],
      headers: [
        { text: "", value: "stateKey" },
        {
          text: "№",
          align: "start",
          sortable: false,
          value: "index"
        },
        {
          text: "Мед. учреждение",
          sortable: true,
          value: "organization.fullName",
          color: "red"
        },
        { text: "Доктор", value: "doctor.fullName" },
        { text: "Номер счета", value: "invoiceNumber" },
        { text: "Дата введения", sortable: true, value: "postingDate4List" },
        { text: "Дата обращения", sortable: true, value: "visitDate4List" },
        { text: "Диагноз", sortable: true, value: "diagnosis.label" },
        { text: "Услуга", sortable: true, value: "serviceName4List" },
        { text: "Категория", sortable: true, value: "serviceCategory.name" },
        { text: "Кол-во", sortable: true, value: "quantity" },
        { text: "% Скидка", sortable: true, value: "discountPercent" },
        { text: "Сумма", sortable: true, value: "amount" },
        { text: "Со скидкой", sortable: true, value: "discountedAmount" },
        { text: "Контрольный номер", sortable: false, value: "checkNumber" }
      ],
      items: [],
      item: undefined,
      dialog: false,
      dialogDelete: false,
      addItem: undefined,
      searchText: undefined,
      serviceDetail: undefined
    }),
    watch: {
      "vm.item": function(val) {
        this.selected = [];
        this.items = [];
        if (val) return this.fetchItems();
      },
      selected: function(val) {
        if (val.length === 0) this.item = undefined;
        else {
          this.item = new Item(vm2js(val[0]));
        }
      }
    },
    computed: {
      formTitle() {
        return this.addItem && !this.addItem.id
          ? "Новая запись"
          : "Редактирование записи";
      }
    },
    methods: {
      buildServiceLookup(activeServices) {
        const lookup = {};
        (ctx.src.services.items || []).forEach(service => {
          lookup[service.id] = service;
        });
        (activeServices || []).forEach(service => {
          lookup[service.id] = service;
        });
        return lookup;
      },
      pushServiceItem(row, serviceLookup) {
        this.items.push(new Item(row, serviceLookup));
      },
      itemColor(item) {
        if (
          moment(item.visitDate) <
          moment(
            this.byInvoice
              ? this.vm.insured.item.startDate
              : this.vm.item.startDate
          ) ||
          moment(item.visitDate) >
          moment(
            this.byInvoice ? this.vm.insured.item.endDate : this.vm.item.endDate
          )
        )
          return "item-red";
        return "";
      },
      add() {
        this.close();
        this.selected.push(new Item({ insuredId: this.vm.item.id, isNew: true })); 
      },
      async addBlank() {
        const res = await fetch.post(
          "/api/accounting/referral-blank/save?invoiceServiceId=" + this.item.id
        );
        if (res && this.vm.blanksList) this.vm.blanksList.fetchItems();
      },
      async deleteConfirm() {
        const res = await fetch.post(
          "/api/accounting/invoices/delete-service?id=" + this.item.id
        );
        if (res) {
          this.selected = [];
          if (this.vm.refreshDetail) this.vm.refreshDetail();
          this.dialogDelete = false;
        }
      },
      async save() {
        let arr = [];
        let item = vm2js(this.item);
        if (item.id) {
          item.id = undefined;
          item.amount = item.amount - this.selected[0].amount;
          item.quantity = item.quantity - this.selected[0].quantity;
        }
        this.limitCheck.setItem(this.item);
        arr.push(item);
        const checkRes = await this.limitCheck.check(
          this.item.insuredId,
          this.item.serviceCategoryId,
          this.item.discountedAmount,
          this.item.quantity,
          this.item.id

        );

        const res = await fetch.post(
          "/api/accounting/invoices/save-service",
          vm2js(this.item)
        );
        if (res) {
          this.close();
          if (this.vm.refreshDetail) this.vm.refreshDetail();
        }
      },
      close() {
        this.selected = [];
      },
      async fetchItems() {
        this.items = [];
        this.loading = true;

        await ctx.src.services.init();
        const activeServices = await fetch.get(
          "/api/accounting/services/get-active-services?insuredId=" +
            this.vm.item.id
        );
        const serviceLookup = this.buildServiceLookup(activeServices);

        let res = await fetch.get(
          "/api/accounting/invoices/get-services-by-insured?insuredId=" +
          this.vm.item.id
        );
        if (res) {
          res.forEach(r => {
            this.pushServiceItem(r, serviceLookup);
          });
        }
        this.loading = false;
      },
      rowClick(obj, row) {
        if (!row.isSelected) row.select(obj);
        else this.selected = [];
      }
    },
    mounted() {
      if (this.vm) this.vm.servicesList = this;
      this.fetchItems();
    },
    components: {
      SaveButton,
      ServiceDetail,
      CheckLimit,
      ServiceHistory
    }
  };
</script>

<style lang="scss" scoped>
  .this-wrapper {
    height: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .this-wrapper::v-deep .v-data-table__wrapper {
    > table {
      counter-reset: section;
      tbody tr td:nth-child(3)::before {
        counter-increment: section;
        content: counter(section);
      }
    }
  }
</style>
